import React from 'react';
import {
  FaBolt,
  FaThumbsUp,
  FaReply,
  FaDollarSign,
  FaSmile,
  FaChevronRight
} from 'react-icons/fa';
import './about_me.css';

const ICON_SIZE = 32;

export default function AboutMe() {
  const introText =
    "We are a team of certified appliance repair professionals committed to fast, reliable service with transparent pricing and complete customer satisfaction.";

  const features = [
    {
      icon: <FaBolt size={ICON_SIZE} />,
      title: 'High‑Speed Repair',
      description: 'Repair takes no longer than 3 hours.'
    },
    {
      icon: <FaThumbsUp size={ICON_SIZE} />,
      title: 'Reliable Service',
      description: 'We provide a 180‑days warranty on all repairs.'
    },
    {
      icon: <FaReply size={ICON_SIZE} />,
      title: 'Quick Response',
      description: 'We’ll call you back shortly after your request.'
    },
    {
      icon: <FaDollarSign size={ICON_SIZE} />,
      title: 'Free Service Call',
      description: (<>
        No charge for initial diagnostics.*
        <small className="note-text">
          *If you choose repair with us
        </small>
      </>)
    }
  ];

  const processSteps = [
    {
      title: 'Request',
      description:
        'Fill out Request Repair form or call us. Provide necessary information about your appliance and malfunction.'
    },
    {
      title: 'Confirmation',
      description:
        'We will call you back as soon as possible. We will also send you notification email. \
        Same day repair is available depending on your location and preffered time.'
    },
    {
      title: 'Diagnostic',
      description:
        'Our expert technician arrives on time, fully equipped, and runs a thorough diagnostic.'
    },
    {
      title: 'Price',
      description:
        'Once the technician diagnoses the issue, he will outline needed parts and walk you through the estimate so you know exactly what you’re paying. \
        You can approve or ask questions before they begin.'
    },
    {
      title: 'Repair',
      description:
        'Once approved, our expert get to work immediately. Repairs are fast but never rushed, ensuring lasting results.'
    }
  ];

  const satisfied = {
    title: 'Satisfied Customer',
    description:
      'Enjoy the peace of mind that comes with our 30‑day service guarantee and friendly follow‑up. We’re only happy when you are—reach out any time if you need further assistance.'
  };

  return (
    <section id="about-us" className="about-us">
      {/* — About Us heading & features — */}
      <h2>ABOUT US</h2>
      <p className="about-intro">{introText}</p>
      <div className="features">
        {features.map((f, i) => (
          <div key={i} className="feature-card">
            <div className="icon-squircle">{f.icon}</div>
            <div className="feature-text">
              <h4>{f.title}</h4>
              <p>{f.description}</p>
            </div>
          </div>
        ))}
      </div>

      <h2 id="repair-steps" className="process-header">
        HOW WE REPAIR YOUR APPLIANCE IN 5 EASY STEPS
      </h2>
      <div className="process-flow">
        {processSteps.map((step, i) => (
          <React.Fragment key={i}>
            <div className="process-step">
              <h5 className="process-title">{step.title}</h5>
              <div className="process-box">
                <p className="process-desc">{step.description}</p>
              </div>
            </div>
            {/* <FaChevronRight className="process-arrow" /> */}
          </React.Fragment>
        ))}

        <div className="process-step final-step">
          <h5 className="process-title">Satisfied Customer</h5>
          <div className="final-icon-container">
            <FaSmile className="final-smile-icon" />
          </div>
        </div>
      </div>
    </section>
  );
}